import { Icon as _Icon, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const Icon = styled(_Icon)``;

export const DivIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonIconWrapper = styled.button<{ isSearch?: boolean }>`
  margin: 3px;
  padding: 9px;
  ${({ isSearch }) =>
    isSearch &&
    `
    ${mq.pc} {
      display: none;
    }
  `}
  div > svg {
    width: 24px;
    height: 24px;
  }
  ${mq.sp} {
    div > svg {
      width: 20px;
      height: 20px;
    }
    margin: 0px;
    padding: 12px;
  }
`;

export const AnchorIconWrapper = styled.a`
  margin: 3px;
  padding: 9px;

  div > svg {
    width: 24px;
    height: 24px;
  }
  ${mq.sp} {
    div > svg {
      width: 20px;
      height: 20px;
    }
    margin: 0px;
    padding: 12px;
  }
`;
